package com.example.hukakmp.model

/**
 * Modalidades de pesca portadas desde Huka Android.
 * `displayName` conserva los textos que ya usa Reportes para mantener compatibilidad.
 * `emoji` se usa únicamente en la interfaz para hacer la selección más rápida y visual.
 */
enum class ModalidadPesca(
    val displayName: String,
    val usaCanas: Boolean,
    val emoji: String,
) {
    COSTA_LINEA("con línea costa", usaCanas = true, emoji = "🎣"),
    EMBARCADO_LINEA("con línea embarcación", usaCanas = true, emoji = "🚤"),
    SUBMARINA_COSTA("submarina costa", usaCanas = false, emoji = "🤿"),
    SUBMARINA_EMBARCADO("submarina embarcación", usaCanas = false, emoji = "🤿🚤"),
    RED("con red", usaCanas = false, emoji = "🕸️"),
    OTRA("otra", usaCanas = false, emoji = "➕"),
}

/** Una fila del paso "especies" del wizard. */
data class EspecieEntry(
    val especie: String = "",
    val cantidad: Int = 0,
    val devueltos: Int = 0,
)

/**
 * Foto seleccionada en cámara o galería. Los bytes se mantienen sólo mientras se completa
 * el wizard y se suben a Firebase Storage al confirmar el parte.
 */
data class FotoSeleccionada(
    val nombre: String,
    val bytes: ByteArray,
    val contentType: String = "image/jpeg",
)

/**
 * Estado completo del formulario guiado. Mantiene las mismas reglas esenciales de Huka:
 * fecha/horarios, modalidad, ubicación y fotografía obligatorias; capturas y observaciones
 * opcionales.
 */
data class NuevoParteInput(
    val fecha: String = "",
    val horaInicio: String = "",
    val horaFin: String = "",
    val modalidad: ModalidadPesca? = null,
    val modalidadOtra: String = "",
    val numeroCanas: Int? = null,
    val nombreLugar: String = "",
    val zona: String = "",
    val latitud: String = "",
    val longitud: String = "",
    val especies: List<EspecieEntry> = emptyList(),
    val fotos: List<FotoSeleccionada> = emptyList(),
    val observaciones: String = "",
)
